import {FormBuilder, Validators, FormGroup} from '@angular/forms';
import {Injectable} from '@angular/core';

@Injectable()
export class OrganisationValidator {
  private form: FormGroup;
  private model: any;
  private userControlsConfig = {
    create: {
      email: ['', Validators.required],
      password: ['', Validators.required],
      name: ['', Validators.required],
      phone: ['', Validators.required],
      phone_country_code: ['', Validators.required],
      organisation_name: ['', Validators.required],
      organisation_ean_nr: ['', Validators.required],
      organisation_country: ['', Validators.required],
      organisation_county: ['', Validators.required],
      organisation_city: ['', Validators.required],
      organisation_postalcode: ['', Validators.required],
      organisation_address: ['', Validators.required],
      organisation_invoice_email: [''],
      organisation_type: [''],
      newsletter_opt_in: [null, Validators.required]
    },
    update: {
      email: ['', Validators.required],
      name: ['', Validators.required],
      phone: ['', Validators.required],
      phone_country_code: ['', Validators.required],
      organisation_name: ['', Validators.required],
      organisation_ean_nr: ['', Validators.required],
      organisation_country: ['', Validators.required],
      organisation_county: ['', Validators.required],
      organisation_city: ['', Validators.required],
      organisation_postalcode: ['', Validators.required],
      organisation_address: ['', Validators.required],
      organisation_invoice_email: [''],
      notify_job_published: [''],
      password: [''],
      //newsletter_opt_in: [null, Validators.required]
    }
  };

  constructor(private fb: FormBuilder) {
  }

  init(model, rules = 'create') {
    this.form = this.fb.group(this.userControlsConfig[rules]);
    this.model = model;

    // Prefill fields when type changed to individual
    if(rules === 'create'){
      this.form.get('organisation_type').valueChanges
        .subscribe((value) => this.onOrganisationTypeValueChanges(value));
    }

    return this.form;
  }

  onOrganisationTypeValueChanges(value) {

    if (value === 'individual') {
      this.model.organisation.name = this.model.name;
    }

    this.setRequired('organisation_country', value === 'individual');
    this.setRequired('organisation_county', value === 'individual');
    this.setRequired('organisation_city', value === 'individual');
    this.setRequired('organisation_postalcode', value === 'individual');
    this.setRequired('organisation_address', value === 'individual');

    return value;
  }

  private setRequired(controlName, ifCond) {
    let field = this.form.get(controlName);
    field.setValidators(ifCond ? Validators.required : null);
    field.updateValueAndValidity();
  }

  setFormDisabledState() {
    let fields = ['organisation_name', 'organisation_ean_nr', 'organisation_country',
      'organisation_county', 'organisation_city', 'organisation_postalcode', 'organisation_address'];
    for (let fieldName of fields) {
      let control = this.form.get(fieldName);
      control.disable();
      control.clearValidators();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/signup/interpreter-signup/organisation.validator.ts